import { HCO_CUBE_NAME } from '@/api/hco/constants';
import mapDimensionToOption from '@/models/filter/utils/mapDimensionToOption';
import { GetOptionsQueryFunction } from '@/types/cube';
import { FilterConfigDynamic } from '@/types/filter';
import { HCO_PRIVATE_PUBLIC_STATUS_FILTER_LIMIT } from '../../filterDefaultLimits';

const HCO_PRIVATE_PUBLIC_STATUS_OPTIONS: GetOptionsQueryFunction = ({ sourceCube }) => ({
  dimensions: [`${sourceCube}.private_public_status`],
  limit: HCO_PRIVATE_PUBLIC_STATUS_FILTER_LIMIT,
});

const hcoPrivatePublicStatusFilter: FilterConfigDynamic = {
  label: 'global.filters.formControls.hcoPrivatePublicStatusLabel',
  placeholder: 'global.filters.formControls.hcoPrivatePublicStatusPlaceholder',
  type: 'multiselect',
  defaultValue: [],
  searchable: true,
  clearable: true,
  applyDynamicFilters: true,
  sourceCube: HCO_CUBE_NAME,
  getOptionsQuery: HCO_PRIVATE_PUBLIC_STATUS_OPTIONS,
  mapResult: mapDimensionToOption(`${HCO_CUBE_NAME}.private_public_status`),
  applyFilter: value => {
    const selected = Array.isArray(value) ? value.map(String) : [];
    if (selected.length === 0) return undefined;
    return {
      member: `${HCO_CUBE_NAME}.private_public_status`,
      operator: 'equals',
      values: selected,
    };
  },
};

export default hcoPrivatePublicStatusFilter;
